import { render, staticRenderFns } from "./Flowxrftablevn.vue?vue&type=template&id=8a812cc0&scoped=true"
import script from "./Flowxrftablevn.vue?vue&type=script&lang=js"
export * from "./Flowxrftablevn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a812cc0",
  null
  
)

export default component.exports